import $ from 'jquery';
import attachEnterAsClick from 'utils/attachEnterAsClick';

const fileUploaderInit = () => {
    $('.file-uploader-wrapper').each(function () {
        const $uploaderWrapper = $(this);
        const $uploaderInput = $('.uploader-input-file', this);

        if ($(this).hasClass('kentico-file-uploader-wrapper')) {
            const $uploaderDiv = $('.uploader-upload', $uploaderWrapper);

            $('label', $uploaderWrapper)
                .clone()
                .addClass('btn btn-skin-1') // style it.
                .html('Select File') // update the copy
                .attr('tabindex', '0')
                .prependTo($uploaderDiv); // place it where we need it.

            // Add span for displaying the file name
            $uploaderDiv.append('<span class="filename-span"></span>');
        }

        // disabled state
        if ($(this).hasClass('is-disabled') || $uploaderInput.hasClass('aspNetDisabled') ||
            $uploaderInput.is(':disabled')) {
            $('.uploader-upload label', this).addClass('btn-disabled');
            $('.uploader-upload label', this).on('click keypress', e => {
                e.preventDefault();
            });
        }

        // accessibility
        attachEnterAsClick($('label', this));

        $uploaderInput.on('change', function () {
            if (this.value) {
                $(this).siblings('span.filename-span').text(this.value);
            }
        });
    });
};

$(() => {
    fileUploaderInit();
});



// WEBPACK FOOTER //
// ./src/components/form-elements/file-uploader/c-file-uploader.js